import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-1 text-zinc-500 hover:text-white text-xs font-mono mb-6">
          <ArrowLeft size={14} /> Back
        </Link>
        <h1 className="text-3xl font-black mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Privacy Policy</h1>
        <div className="prose prose-invert prose-sm max-w-none space-y-4 text-zinc-300">
          <p><strong>Effective Date:</strong> {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
          <p>RAW COMPANY TECH LIMITED (Company No. 17349121) is the data controller for Racing Form Guide, in compliance with UK GDPR and Data Protection Act 2018.</p>
          <h2 className="text-white text-lg font-bold mt-6">Data We Collect</h2>
          <p>Account data (name, email, encrypted password), payment data (via Stripe - we don't store cards), and usage data.</p>
          <h2 className="text-white text-lg font-bold mt-6">How We Use It</h2>
          <p>To provide the Service, process payments, and improve our algorithms.</p>
          <h2 className="text-white text-lg font-bold mt-6">Your Rights</h2>
          <p>Under UK GDPR: access, rectification, erasure, restriction, portability, objection. Contact: orders@rawcompanytech.com</p>
          <h2 className="text-white text-lg font-bold mt-6">Cookies</h2>
          <p>Essential authentication cookies only. No advertising or tracking cookies.</p>
          <h2 className="text-white text-lg font-bold mt-6">Security</h2>
          <p>SSL/TLS encryption, bcrypt password hashing, secure hosting.</p>
        </div>
        <div className="border-t border-zinc-800 mt-8 pt-4 text-[10px] text-zinc-600 text-center font-mono">
          &copy; {new Date().getFullYear()} RAW COMPANY TECH LIMITED &middot; Company No. 17349121
        </div>
      </div>
    </div>
  );
}
